document.addEventListener('DOMContentLoaded', function () {

  // Silk canvas — WebGL displacement on photo
  var silkCv = document.getElementById('nojoom-silk-canvas');
  var imgEl  = document.querySelector('[data-img]');
  if (silkCv && imgEl) {
    var imgUrl = imgEl.getAttribute('data-img');
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function() { initSilk(silkCv, img); };
    img.src = imgUrl;
  }

  function initSilk(cv, img) {
    var W = cv.offsetWidth, H = cv.offsetHeight;
    cv.width  = W * devicePixelRatio;
    cv.height = H * devicePixelRatio;
    var gl = cv.getContext('webgl');
    if (!gl) return;

    var vSrc = [
      'attribute vec2 a_pos;',
      'varying vec2 v_uv;',
      'void main(){',
      '  v_uv = a_pos * 0.5 + 0.5;',
      '  gl_Position = vec4(a_pos, 0.0, 1.0);',
      '}'
    ].join('\n');

    var fSrc = [
      'precision mediump float;',
      'uniform sampler2D u_tex;',
      'uniform float u_time;',
      'uniform vec2 u_res;',
      'varying vec2 v_uv;',
      'void main(){',
      '  vec2 uv = v_uv;',
      '  float t = u_time * 0.38;',
      // Cover-fit: map uv to fill canvas keeping image proportions
      '  float imgAsp = ' + (img.width / img.height).toFixed(4) + ';',
      '  float canAsp = u_res.x / u_res.y;',
      '  vec2 scale = canAsp > imgAsp',
      '    ? vec2(1.0, imgAsp / canAsp)',
      '    : vec2(canAsp / imgAsp, 1.0);',
      '  scale *= 1.5;',
      '  uv = (uv - 0.5) / scale + 0.5;',
      // Cinematic slow wind displacement
      '  float dx = sin(uv.y * 3.2 + t * 0.9) * 0.055',
      '           + sin(uv.y * 6.5 - t * 0.6) * 0.028',
      '           + cos(uv.x * 4.0 + t * 0.5) * 0.018;',
      '  float dy = cos(uv.x * 2.8 + t * 0.7) * 0.045',
      '           + sin(uv.x * 5.5 - t * 0.8) * 0.022',
      '           + sin(uv.y * 3.5 + t * 0.4) * 0.015;',
      '  vec2 wuv = uv + vec2(dx, dy);',
      // Clamp to avoid border artifacts
      '  wuv = clamp(wuv, 0.001, 0.999);',
      '  vec4 col = texture2D(u_tex, wuv);',
      // Subtle shimmer highlight
      '  float shine = sin(uv.x * 8.0 + t * 1.2 + dx * 30.0) * 0.5 + 0.5;',
      '  shine = pow(shine, 6.0) * 0.06;',
      '  col.rgb += shine;',
      '  gl_FragColor = col;',
      '}'
    ].join('\n');

    function makeShader(type, src) {
      var s = gl.createShader(type);
      gl.shaderSource(s, src);
      gl.compileShader(s);
      return s;
    }
    var prog = gl.createProgram();
    gl.attachShader(prog, makeShader(gl.VERTEX_SHADER, vSrc));
    gl.attachShader(prog, makeShader(gl.FRAGMENT_SHADER, fSrc));
    gl.linkProgram(prog);
    gl.useProgram(prog);

    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1, 1,-1, -1,1, 1,1]), gl.STATIC_DRAW);
    var aPos = gl.getAttribLocation(prog, 'a_pos');
    gl.enableVertexAttribArray(aPos);
    gl.vertexAttribPointer(aPos, 2, gl.FLOAT, false, 0, 0);

    var tex = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, img);

    var uTime = gl.getUniformLocation(prog, 'u_time');
    var uRes  = gl.getUniformLocation(prog, 'u_res');
    gl.uniform2f(uRes, cv.width, cv.height);

    var t = 0;
    (function tick() {
      requestAnimationFrame(tick);
      t += 0.016;
      gl.uniform1f(uTime, t);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    })();

    window.addEventListener('resize', function() {
      W = cv.offsetWidth; H = cv.offsetHeight;
      cv.width = W * devicePixelRatio; cv.height = H * devicePixelRatio;
      gl.viewport(0, 0, cv.width, cv.height);
      gl.uniform2f(uRes, cv.width, cv.height);
    });
  }

  // Add to cart
  document.querySelectorAll('.n-pcard__add button[data-variant-id]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(id), quantity: 1 })
      }).then(function(){ btn.textContent = '✦ Added'; setTimeout(function(){ btn.textContent = 'Add to Bag'; }, 2000); })
        .catch(function(){ btn.textContent = 'Add to Bag'; });
    });
  });
});
